<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XS1uBw/tc-custom/9781783032051.jpg?1721404630394" alt="This image is the cover for the book Armed Forces of the European Union, 2012–2013"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Armed Forces of the European Union, 2012–2013
      </h1>
      <p class="bookDescription body article font2">
        <b>Military expert Charles Heyman’s <i>The Armed Forces of the European Union, 2012–2013</i> presents an overview of one of the world’s largest military forces.</b><br/><br/>The European Union’s member states have defense forces that include more than 1.6 million personnel and inventories that include more than 35,000 armored vehicles, 2,000 combat aircraft, sixty submarines and over 140 major surface vessels. This indispensable volume includes important facts and figures related to European defense, details concerning the European Union Military Committee and the European Defense Agency. <br/><br/>Also included is information about European Union military roles, the Eurocorps and European Union Battlegroups. In addition, there are details regarding the force structure of the member states and characteristics of the major land, sea and air equipment.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Heyman
      </h2>
      
      <p class="authorDescription body article">Charles Heyman is an expert in current military personnel and vehicles – air, land and sea.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?084dfef2